import CustomInput from './CustomInput';
import React, { useCallback } from 'react';
import { turkishToUpper } from '@src/utils/utils';

const CustomTextInput = ({ onChange, toUpperCase=false, hasNumberChar=false ,...props}) => {
    const change = useCallback(
        (e) => {
            const { value } = e.target;
            let regex = /^[a-zA-ZğüşöçıİĞÜŞÖÇ ]+$/;
            if(hasNumberChar){
              regex = /^[a-zA-Z0-9ğüşöçıİĞÜŞÖÇ ]+$/;
            }
            if (regex?.test(value) || value === '' || value === '-') {
                toUpperCase ? onChange(turkishToUpper(value)) :onChange(value);
            } else {
                const textWithoutLastChar = value?.slice(0, -1);
                toUpperCase ? onChange(turkishToUpper(textWithoutLastChar)) : onChange(textWithoutLastChar);
            }
        },
        [onChange,toUpperCase],
    );

    return <CustomInput {...props} onChange={change} />;
};

export default CustomTextInput;
